import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

import { DatabaseProvider } from '../../providers/database/database';

import { SmpAddPage } from '../smp-add/smp-add';
//import { SMPItem } from './smpitem';
/**
 * Generated class for the SmpPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'page-smp',
  templateUrl: 'smp.html',
})
export class SmpPage {

  constructor(public navCtrl: NavController, public navParams: NavParams,
                public dbProvider: DatabaseProvider) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SmpPage');
  }

  addSmp(){
    console.log('addSmp() called...');
    this.navCtrl.push(SmpAddPage, {});
  }

}



// WEBPACK FOOTER //
// ./src/pages/smp/smp.ts